import React, { useContext, useEffect } from "react";
import styles from "./Signin.module.scss";
import Paragraph from "../../elements/Paragraph";
import Input from "../../elements/Input";
import Button from "../../elements/Button/Button";

import { Context, AuthorizationContext } from "../../../store/authorization";
import { handleInputChange } from "helpers/form";
import { RouteComponentProps } from "react-router";
import Avatar from "components/elements/Avatar";
import AvatarIcon from "assets/svg/avatar.svg";
import Select from "components/elements/Select";

interface Props extends RouteComponentProps {}

const Signin: React.FC<Props> = (props) => {
  const { history } = props;
  const { state, fetchAvailableHosts, setSignInFormValue, signIn } =
    useContext<AuthorizationContext>(Context);

  const {
    availableHostsFetching,
    availableHostsError,
    availableHosts,
    filteredHosts,
    signInForm,
    signingIn,
    signingInError,
    authorizedHost,
  } = state;

  const selectedHost = availableHosts.find(
    (host) => host.id === state.signInForm.values.id
  );

  const submit = () => {
    if (!selectedHost) {
      return;
    }

    signIn(
      selectedHost,
      signInForm.values.password,
      signInForm.values.hotelCode
    );
  };

  useEffect(() => {
    fetchAvailableHosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (authorizedHost && authorizedHost.isMapscreen) {
      history.push("/locations");
    } else if (authorizedHost) {
      history.push("/");
    }
  }, [authorizedHost, history]);

  return (
    <div className={styles.wrapper}>
      <img
        className={styles.logo}
        alt="CityHub"
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iMzciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM1LjMwOCA5Ljg0N2wuMTI0LS4xNjUgMS45MzggMS43ODItLjExLjE0NGMtMS4yMjQgMS42MS0zLjE4NCAyLjUzMi01LjM3NiAyLjUzMi0zLjg2OSAwLTYuNzg2LTIuOTIyLTYuNzg2LTYuNzk1QzI1LjA5OCAzLjQ3IDI4IC41NSAzMS44NDguNTVjMS44IDAgMy40NjQuNjcgNC42ODQgMS44ODhsLjEzNC4xMzQtMS44MDkgMS45NzMtLjEzOC0uMTQyYy0uNzktLjgxNS0xLjgxNS0xLjI2My0yLjg4OS0xLjI2My0yLjIxNyAwLTMuOTUzIDEuODQ3LTMuOTUzIDQuMjA1IDAgMi4zOTcgMS43NDUgNC4yMDUgNC4wNiA0LjIwNSAxLjgyMiAwIDIuODk0LTEuMDY3IDMuMzcxLTEuNzAzem0yLjk3MS01LjE3MmgyLjY5djkuMjgxaC0yLjY5VjQuNjc1em0xLjM0NS0xLjI0MmExLjY5IDEuNjkgMCAwIDEtMS43LTEuNzE3QTEuNjkgMS42OSAwIDAgMSAzOS42MjQgMGMuOTU0IDAgMS43Ljc1NCAxLjcgMS43MTZhMS42OSAxLjY5IDAgMCAxLTEuNyAxLjcxN3ptNC43MjQgNi41N1Y3LjA4MWgtMi40VjQuNjc1aDIuNFYyLjJoMi42OXYyLjQ3NWgyLjg0NFY3LjA4aC0yLjg0NXYzLjE5N2MwIC40OS4wNzIuNzg4LjI0Ljk5Mi4yMDcuMjQ2LjU1My4zNzEgMS4wMy4zNzEuMzE4IDAgLjc0Ni0uMDUxLjktLjA4N2wuMTkzLS4wNDQuNDIgMi4zOC0uMTUzLjA1NWMtLjMzLjEyLTEuMDM3LjE5NS0xLjUwMy4xOTUtMS40MDUgMC0yLjQ5LS40NzEtMy4xMzgtMS4zNjItLjQ3Ni0uNjQ2LS42NzgtMS40NzctLjY3OC0yLjc3NXptNy43MDMgOC4zNTNsMi40Ny01LjQ5LTMuOTU0LTguMTkxaDIuOTY2bDIuNCA1LjA3IDIuMjEzLTUuMDdINjFsLTYuMTEzIDEzLjY4MWgtMi44MzZ6bS00Mi43ODkgOS4zOHYtNC44NmgyLjc3OVYzNi4xSDkuMjYydi01Ljc3NUgzLjQxN1YzNi4xSC42MzhWMjIuODc3aDIuNzh2NC44NThoNS44NDR6bTEwLjY5MiA0Ljk4NHYtNS45MDJoMi42OVYzNi4xaC0yLjZ2LS41MDVhMy41NjggMy41NjggMCAwIDEtMi4xNDEuNjg4IDMuOTQ1IDMuOTQ1IDAgMCAxLTMuMDgtMS41MDJjLS42MTYtLjc3Ny0uOTE0LTEuNzc3LS45MTQtMy4wNTZ2LTQuOTA3aDIuNjl2NC45OTljMCAuODM0LjE4MiAxLjE2Mi4zOCAxLjM5Mi4zNy40MjEuODgzLjQ4NCAxLjE1NS40ODQuOTQxIDAgMS41OTItLjY4OSAxLjgyLS45NzN6bTcuMzM2LTIuNTI0YTIuNDMgMi40MyAwIDAgMSAxLjk0NC0uOTdjMS4zMjEgMCAyLjAzNCAxLjE1NSAyLjAzNCAyLjI0MiAwIDEuMjktLjg3OCAyLjIyNS0yLjA4NyAyLjIyNS0uNzU2IDAtMS40NTktLjM2LTEuODkxLS45Njd2LTIuNTN6bTIuMjQ3LTMuNTZjMi40NzkgMCA0LjQyIDIuMTIyIDQuNDIgNC44MzIgMCAxLjIwOC0uNDA3IDIuMzYtMS4xNDcgMy4yNDQtLjgyLjk4NC0yLjA5IDEuNTcxLTMuMzk4IDEuNTcxYTMuNzE2IDMuNzE2IDAgMCAxLTIuMjEtLjY5N3YuNTE0SDI0LjZWMjIuNjkzaDIuNjl2NC41ODRjLjY0NC0uNDI2IDEuMzk4LS42NDIgMi4yNDctLjY0MnptMjkuNzYtNS4xNTNjLjczNiAwIDEuMzM1LjYxNyAxLjMzNSAxLjM3NXYxMC4wMjhINDEuODRjLS43MzUgMC0xLjMzNC0uNjE3LTEuMzM0LTEuMzc1IDAtLjc1OS41OTktMS4zNzUgMS4zMzQtMS4zNzVoMTYuMTI0di03LjI3OGMwLS43NTguNTk5LTEuMzc1IDEuMzM0LTEuMzc1ek0yLjAxNSAxNy4yYy0uNzM2IDAtMS4zMzQtLjYxNy0xLjMzNC0xLjM3NVY1Ljc5N2gxOC43OTJjLjczNSAwIDEuMzMzLjYxNyAxLjMzMyAxLjM3NSAwIC43NTktLjU5OCAxLjM3NS0xLjMzMyAxLjM3NUgzLjM0N3Y3LjI3OGMwIC43NTgtLjU5OCAxLjM3NS0xLjMzMyAxLjM3NXoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="
      />
      <div>
        {availableHostsFetching && <Paragraph>Loading hosts...</Paragraph>}
        {availableHostsError && (
          <Paragraph error>Error loading hosts...</Paragraph>
        )}
        {selectedHost && (
          <ul className={styles.hostsWrapper}>
            <li
              onClick={() => {
                setSignInFormValue("id", null);
                setSignInFormValue("name", "");
              }}
            >
              <Avatar
                crown={selectedHost.isAdmin}
                sunglasses={selectedHost.isWatcher}
                src={selectedHost.Picture}
                alt={selectedHost.FirstName}
              />
              <Paragraph small>{selectedHost.FirstName}</Paragraph>
            </li>
          </ul>
        )}
        {!selectedHost && signInForm.values.name.length === 0 && (
          <ul className={styles.hostsWrapper}>
            <li>
              <Avatar src={AvatarIcon} alt="Welcome" />
              <Paragraph small={true}>Welcome</Paragraph>
            </li>
          </ul>
        )}
        {!selectedHost &&
          signInForm.values.name.length !== 0 &&
          !availableHostsFetching &&
          filteredHosts.length === 0 && (
            <ul className={styles.hostsWrapper}>
              <li>
                <Avatar src={AvatarIcon} alt="Welcome" />
                <Paragraph small>No profiles found</Paragraph>
              </li>
            </ul>
          )}
        {!selectedHost &&
          signInForm.values.name.length > 0 &&
          !availableHostsFetching &&
          !availableHostsError &&
          filteredHosts.length > 0 && (
            <ul className={styles.hostsWrapper}>
              {filteredHosts
                .sort((a, b) => (a.FirstName > b.FirstName ? 1 : -1))
                .map((host) => (
                  <li
                    key={host.id}
                    onClick={() => {
                      setSignInFormValue("id", host.id);
                      setSignInFormValue("hotelCode", host.DefaultHotelCode);
                    }}
                  >
                    <Avatar
                      crown={host.isAdmin}
                      sunglasses={host.isWatcher}
                      src={host.Picture}
                      alt={host.FirstName}
                    />
                    <Paragraph small>{host.FirstName}</Paragraph>
                  </li>
                ))}
            </ul>
          )}
      </div>
      <Paragraph>Fill in your name and select your profile</Paragraph>
      {!selectedHost && (
        <div className={styles.formWrapper}>
          <Input
            type="search"
            name="name"
            placeholder="Name"
            value={signInForm.values.name}
            onChange={handleInputChange(setSignInFormValue)}
          />
        </div>
      )}
      {selectedHost && (
        <div className={styles.formWrapper}>
          <Input
            type="password"
            name="password"
            placeholder="Password"
            value={signInForm.values.password}
            onChange={handleInputChange(setSignInFormValue)}
            onKeyDown={(event) => event.key === "Enter" && submit()}
          />
          {signingInError && <Paragraph error>{signingInError}</Paragraph>}
          {signingIn && <Paragraph>Signing in...</Paragraph>}
          <Button onClick={submit}>Login</Button>
          <Select
            name="hotelCode"
            value={signInForm.values.hotelCode}
            onChange={handleInputChange(setSignInFormValue)}
            items={[
              {
                key: "AMS",
                value: "AMS",
                label: "Amsterdam",
              },
              {
                key: "RTM",
                value: "RTM",
                label: "Rotterdam",
              },
              {
                key: "CPH",
                value: "CPH",
                label: "Copenhagen",
              },
              {
                key: "RKV",
                value: "RKV",
                label: "Reykjavík",
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default Signin;
